import { defineStore } from "pinia";

export const useCartStore = defineStore("cart", {
    state: () => ({
        items: [],
    }),
    getters: {
        totalItems: (state) => state.items.reduce((sum, item) => sum + item.quantity, 0),
        totalPrice: (state) => state.items.reduce((sum, item) => sum + item.price * item.quantity, 0),
    },
    actions: {
        addToCart(product) {
            const item = this.items.find((i) => i.id === product.id);
            if (item) {
                item.quantity++;
            } else {
                this.items.push({ ...product, quantity: 1 });
            }
            this.saveToLocalStorage();
        },
        removeFromCart(productId) {
            this.items = this.items.filter((item) => item.id !== productId);
            this.saveToLocalStorage();
        },
        updateQuantity(productId, quantity) {
            const item = this.items.find((i) => i.id === productId);
            if (item) item.quantity = quantity;
        },
        saveToLocalStorage() {
            localStorage.setItem('cart', JSON.stringify(this.items));
        },
        loadFromLocalStorage() {
            const stored = localStorage.getItem('cart');
            if (stored) {
                try {
                    this.items = JSON.parse(stored);
                } catch (e) {
                    console.error('Error', e);
                }
            }
        },
    },
});